import api from 'js/api'

export const signupWithOnboardingService = (
  email: string,
  password: string,
  country: string,
) => api('POST', 'onboarding-service/signup', { email, password, country })
